import { useConfig } from "@/hooks/use-config";
import { useLocale } from "@/hooks/use-locale";
import { useTranslation } from "react-i18next";

export function useFooter() {
  const config = useConfig();
  const locale = useLocale();
  const { t } = useTranslation();

  const baseUrl = config.TAMEENI_HOME;
  const localePath = locale ? `/${locale}` : "/ar";
  const getLink = (path: string) => `${baseUrl}${localePath}${path}`;

  const PRODUCTS_LINKS: { label: string; link: string }[] = [
    { label: t("homepage.car_insurance"), link: getLink("") },
    { label: t("homepage.smeHealth_insurance"), link: getLink("/health-sme") },
    { label: t("homepage.MMP_insurance"), link: getLink("/mmp") },
    {
      label: t("homepage.Domestic Insurance"),
      link: getLink("/domestic-helper"),
    },
    { label: t("homepage.travel_insurance"), link: getLink("/travel") },
    { label: t("homepage.home_insurance"), link: getLink("/home") },
    {
      label: t("homepage.premium_residency"),
      link: getLink("/premium-residency"),
    },
    {
      label: t("homepage.protection_and_saving"),
      link: getLink("/ps"),
    },
    { label: t("homepage.marine_insurance"), link: getLink("/marine") },
  ];

  const RESOURCES_LINKS: { label: string; link: string }[] = [
    { label: t("homepage.faq"), link: getLink("/car/faq") },
    {
      label: t("homepage.blog"),
      link: "https://blog.tameeni.com/",
    },
    {
      label: t("homepage.insurance_authority_publications"),
      link: getLink("/compliance-policy-center"),
    },
    { label: t("homepage.partners"), link: getLink("/partners") },
    { label: t("homepage.career"), link: getLink("/career") },
  ];

  const SUPPORT_LINKS: { label: string; link: string }[] = [
    { label: t("homepage.contact_us"), link: getLink("/contact-us") },
    {
      label: t("homepage.privacy_policy"),
      link: getLink("/privacy-policy"),
    },
    {
      label: t("homepage.terms_and_conditions"),
      link: getLink("/terms-and-conditions"),
    },
  ];

  const menuItems = [
    { label: t("homepage.products"), items: PRODUCTS_LINKS },
    { label: t("homepage.support"), items: SUPPORT_LINKS },
    { label: t("homepage.resources"), items: RESOURCES_LINKS },
  ];

  return {
    menuItems,
  };
}
